import { useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { getUserProfile } from "../features/userProfile/userProfileSlice";

const TutorialGuide = () => {
  const { isAuthenticated } = useKindeAuth();
  const dispatch = useDispatch();
  const driverRef = useRef(null);
  const userProfileState = useSelector((state) => state.userProfile);
  const location = useLocation();

  // Load user profile if not already loaded
  useEffect(() => {
    if (
      isAuthenticated &&
      !userProfileState.profile &&
      !userProfileState.isLoading
    ) {
      dispatch(getUserProfile());
    }
  }, [
    isAuthenticated,
    dispatch,
    userProfileState.profile,
    userProfileState.isLoading,
  ]);

  useEffect(() => {
    if (
      isAuthenticated &&
      userProfileState?.profile?.bsa_number &&
      (location.pathname === "/" || location.pathname === "/my-record")
    ) {
      // Only show tutorial on home page or my-record page if user has a BSA number
      const hasSeenTutorial = localStorage.getItem("pba_tutorial_seen");

      if (!hasSeenTutorial) {
        // Set flag BEFORE starting tutorial
        localStorage.setItem("pba_tutorial_seen", "true");

        // Initialize driver.js after a short delay
        setTimeout(() => {
          const driverInstance = driver({
            showProgress: true,
            allowKeyboardControl: true,
            overlayOpacity: 0.5,
            disableActiveInteraction: true,
            steps: [
              {
                popover: {
                  title: "Welcome to PBA Ranking System",
                  description:
                    "Let me show you around and explain the key features.",
                  side: "center",
                },
              },
              {
                element: '[data-tutorial="add-entry-button"]',
                popover: {
                  title: "Add Entry",
                  description:
                    "Click here to add a new competition entry to your record.",
                  side: "bottom",
                },
              },
              {
                element: '[data-tutorial="home-button"]',
                popover: {
                  title: "View Rankings",
                  description:
                    "Click here to view the current PBA Rankings. See where all players rank and their qualifying points.",
                  side: "bottom",
                },
              },
              {
                element: '[data-tutorial="my-ranking-button"]',
                popover: {
                  title: "My Ranking",
                  description:
                    "Go to My Ranking to view and manage your competition entries.",
                  side: "bottom",
                },
              },
              //   {
              //     element: '[data-tutorial="profile-menu"]',
              //     popover: {
              //       title: "Profile Menu",
              //       description:
              //         "Click on your profile avatar to access your profile, settings, and sign out.",
              //       side: "left",
              //     },
              //   },
              {
                element: '[data-tutorial="theme-toggle"]',
                popover: {
                  title: "Dark Mode",
                  description:
                    "Toggle between light and dark mode for your preferred viewing experience.",
                  side: "left",
                },
              },
              {
                element: '[data-tutorial="contact-email"]',
                popover: {
                  title: "Contact Us",
                  description:
                    "Have questions? Click here to email us at support@bowlsmaster.co.za",
                  side: "left",
                },
              },
              {
                popover: {
                  title: "You're All Set!",
                  description:
                    "You can restart this tutorial anytime from your profile menu. Enjoy exploring PBA Ranking System!",
                  side: "center",
                },
              },
            ],
          });

          driverRef.current = driverInstance;
          driverInstance.drive();
        }, 500);
      }
    }

    return () => {
      // Cleanup
      if (driverRef.current) {
        driverRef.current.destroy();
      }
    };
  }, [
    isAuthenticated,
    userProfileState?.profile?.bsa_number,
    location.pathname,
  ]);

  return null; // Driver.js handles its own DOM rendering
};

export default TutorialGuide;
